"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.operation_join = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const commonOperationNode_1 = require("../../commonOperationNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const commonProps = (0, commonOperationNode_1.commonZodOperationNodeUtils)(types_1.nodeType, types_1.UiConfigSchema, 'Join');
// create a new UI node of this type.
const createNewNode = ({ id, nodeToCopy }) => {
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            operation: 'join',
            srcArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)('typicallyLoanTape'),
            joinArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)('typicallySupplementalTape'),
            errorOnMissingJoinRow: false,
            joinOnField: 'receivable_id',
            joinFields: [
                {
                    field: 'industry_name',
                    defaultTo: 'no_industry_name',
                },
            ],
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(commonProps.isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.srcArtifactSlug = (0, tape_builder_base_1.asArtifactSlugRef)('PLACEHOLDER');
        nodeData.configuration.joinArtifactSlug = (0, tape_builder_base_1.asArtifactSlugRef)('PLACEHOLDER');
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(commonProps.isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = [
        'file_intermediateTape',
        'file_generatedLoanTape',
        'file_generatedCashBalanceFeed',
        'file_generatedRepaymentTape',
    ];
    const errors = (0, utils_1.checkEdges)({
        isAllowedInputNode: (uiNode) => allowedInputNodes.includes(uiNode.nodeType),
        node,
        graph,
        getUINode,
        minInputs: 2,
        maxInputs: 2,
        minOutputs: 1,
        maxOutputs: 1,
    });
    const friendlyName = commonProps.getFriendlyName(node);
    const inputNodes = (0, utils_1.getSourceNodes)({ node, graph });
    const inputSlugs = [
        node.configuration.srcArtifactSlug,
        node.configuration.joinArtifactSlug,
    ];
    inputNodes.forEach((inputNode) => {
        const inputUINode = getUINode(inputNode);
        const inputFriendlyName = commonProps.getFriendlyName(inputNode);
        if (inputUINode.isOperation || inputUINode.isRaw || inputUINode.isFinal) {
            errors.push(`${friendlyName} cannot use ${inputFriendlyName} as input`);
            return;
        }
        const inputArtifactSlug = inputUINode.getArtifactSlug(inputNode);
        if (!inputSlugs.includes(inputArtifactSlug)) {
            errors.push(`${friendlyName} input ${inputArtifactSlug} is not listed in srcArtifactSlug or joinArtifactSlug`);
        }
    });
    return errors;
};
/**
 * Represents an operation node
 */
exports.operation_join = {
    ...commonProps,
    nodeType: types_1.nodeType,
    operationType: 'tapebuilder_postSanitize',
    createNewNode,
    hasValidConfig,
};
//# sourceMappingURL=uinode.js.map